import React from 'react';
import { TableData, TableRow } from "./StyledResultRow";


export const ResultRowDescription = ( props) => {
    const { row, rowId, index, isDescriptionOpen,  expandedByDefault, } = props;
    return (
        <TableRow
            id={ rowId }
            className={ `description ${ row.type === "resource" ? "extra-padding" : "" } ${ index % 2 === 0 ? "even" : "odd" } ` } /*+ ((row && row.specialBackgroundColor) ? "specialBgColor" : "") } */
        >
            <TableData colSpan={ 7 } className={ "accordionWrapper" }>
                { expandedByDefault && <div className={ "open accordion" }>
                    { decodeURIComponent(String(row.metadata.description || "").replace(/%/g, "%25")) }

                </div> }
                { !expandedByDefault &&
                    <div className={ ( isDescriptionOpen ? "open" : "" ) + " accordion" }>
                        { decodeURIComponent(String(row.metadata.description || "").replace(/%/g, "%25")) }
                    </div> }
            </TableData>
        </TableRow>
    );
}
